<template>
  <div class="input-container pt-0">
    <div class="row lg-flex-dir-col lg-width">
      <div class="col-6">
        <h2>Subscription Dashboard</h2>
      </div>
      <div class="col-6">
        <div class="row mb-6">
          <div class="col-6 d-flex justify-end flex-dir-col">
            <!-- <button
              type="button"
              class="
                btn btn-default
                mt-0
                v-btn v-btn--is-elevated v-btn--has-bg
                theme--light
                v-size--default
                btn-outline
                bg-transparent bg-white
                btn-focus
                ttc
              "
            >
              <span class="v-btn__content">Today</span>
            </button>-->
            <v-btn
              class="btn btn-outline bg-transparent bg-white btn-focus ttc xs-mb-10"
              @click="getSubscriptionDashboardData((tabName = 'all'))"
              :class="{ active: tabName === 'all' }"
            >All</v-btn>
            <v-btn
              class="btn btn-outline bg-transparent bg-white btn-focus ttc xs-mb-10"
              @click="getSubscriptionDashboardData((tabName = 'today'))"
              :class="{ active: tabName === 'today' }"
            >Today</v-btn>

            <v-btn
              class="btn btn-outline bg-transparent bg-white btn-focus ttc xs-mb-10"
              @click="getSubscriptionDashboardData((tabName = 'week'))"
              :class="{ active: tabName === 'week' }"
            >This Week</v-btn>
            <v-btn
              class="btn btn-outline bg-transparent bg-white btn-focus ttc"
              @click="getSubscriptionDashboardData((tabName = 'month'))"
              :class="{ active: tabName === 'month' }"
            >This Month</v-btn>
            <!-- <button
              type="button"
              class="
                btn btn-default
                mt-0
                v-btn v-btn--is-elevated v-btn--has-bg
                theme--light
                v-size--default
                btn-outline
                bg-transparent bg-white
                btn-focus
                ttc
              "
            >
              <span class="v-btn__content">This Week</span>
            </button>
            <button
              type="button"
              class="
                btn btn-default
                mt-0
                v-btn v-btn--is-elevated v-btn--has-bg
                theme--light
                v-size--default
                btn-outline
                bg-transparent bg-white
                btn-focus
                ttc
              "
            >
              <span class="v-btn__content">This Month</span>
            </button>-->
          </div>
          <div class="col-6">
            <div class="datepicker pos-r">
              <datepicker
                v-model="joinOnDateRange"
                @input="dateChange()"
                ref="datepicker"
                :model-config="datePickerConfig"
                :max-date="new Date()"
                is-range
                :masks="{ input: 'DD/MM/YYYY' }"
              >
                <template v-slot="{ inputValue, inputEvents }">
                  <input
                    :value="
                      !!inputValue.start && !!inputValue.end
                        ? inputValue.start + ' - ' + inputValue.end
                        : 'Select Date Range'
                    "
                    v-on="inputEvents.start"
                    class="form-control pos-r"
                    placeholder="Select Date Range"
                  />
                  <div
                    v-if="!!inputValue.start && !!inputValue.end"
                    class="cross-svg subscription-cross-svg"
                    @click="resetJoiningDate"
                  >
                    <crossSVG />
                  </div>
                </template>
              </datepicker>
              <div class="calendarsvg pos-a">
                <calendarSVG />
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>

    <div>
      <div
        class="row flex-wrap-unset ov-both w-nowrap w-100 lg-flex-width sm-mid-flex-width xs-flex-width subscriptionrow mt-0"
        ref="ss"
      >
        <!-- Doctors card -->
        <div class="col-3 cursor">
          <div
            class="cardbox theme--light v-card border-radius-4 h-100"
            @click="goToSubscriptionListing('doctor')"
          >
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <doctorSVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Doctors</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ doctorData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="doctorData.growth > 0" />
                    <upArrowSVG v-if="doctorData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <div>
              <ul class="w-100 pl-6 pr-8 mb-0">
                <li class="d-flex d-just-space align-center pt-3 pb-1">
                  <p class="mb-0 fz-16">Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ doctorData.free_trial }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Basic Plan</p>
                  <p class="mb-0 fz-16">
                    <b>{{ doctorData.basic }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Advance Plan</p>
                  <p class="mb-0 fz-16">
                    <b>{{ doctorData.advance }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Expired</p>
                  <p class="mb-0 fz-16">
                    <b>{{ doctorData.expired }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-3">
                  <p class="mb-0 fz-16">Extended Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ doctorData.ext_free }}</b>
                  </p>
                </li>
              </ul>
            </div>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-2">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Doctors</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0 fz-16">
                    <b class="text-till text-till">{{ doctorData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <!-- <v-skeleton-loader
          v-bind="attrs"
          type="list-item-avatar, divider, image, actions"
          ></v-skeleton-loader>-->
        </div>

        <!-- Allied card -->
        <div class="col-3 cursor">
          <div
            class="cardbox theme--light v-card border-radius-4 h-100"
            @click="goToSubscriptionListing('doctor')"
          >
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <doctorSVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Allied</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ alliedData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="alliedData.growth > 0" />
                    <upArrowSVG v-if="alliedData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <div>
              <ul class="w-100 pl-6 pr-8 mb-0">
                <li class="d-flex d-just-space align-center pt-3 pb-1">
                  <p class="mb-0 fz-16">Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ alliedData.free_trial }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Basic Plan</p>
                  <p class="mb-0 fz-16">
                    <b>{{ alliedData.basic }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Advance Plan</p>
                  <p class="mb-0 fz-16">
                    <b>{{ alliedData.advance }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-1">
                  <p class="mb-0 fz-16">Expired</p>
                  <p class="mb-0 fz-16">
                    <b>{{ alliedData.expired }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space align-center pt-2 pb-3">
                  <p class="mb-0 fz-16">Extended Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ alliedData.ext_free }}</b>
                  </p>
                </li>
              </ul>
            </div>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-2">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Allied</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0 fz-16">
                    <b class="text-till text-till">{{ alliedData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
          <!-- <v-skeleton-loader
          v-bind="attrs"
          type="list-item-avatar, divider, image, actions"
          ></v-skeleton-loader>-->
        </div>

        <!-- Pharmacy card -->
        <div class="col-3 cursor" @click="goToSubscriptionListing('pharmacy')">
          <div class="cardbox theme--light v-card border-radius-4 h-100">
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <pharmacySVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Pharmacy</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ pharmacyData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="pharmacyData.growth > 0" />
                    <upArrowSVG v-if="pharmacyData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <div>
              <ul class="w-100 pl-6 pr-8 mb-0">
                <li class="d-flex d-just-space pt-4 pb-3">
                  <p class="mb-0 fz-16">Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ pharmacyData.free_trial }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Active</p>
                  <p class="mb-0 fz-16">
                    <b>{{ pharmacyData.basic }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Expired</p>
                  <p class="mb-0 fz-16">
                    <b>{{ pharmacyData.expired }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-3 pb-4">
                  <p class="mb-0 fz-16">Extended Free trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ pharmacyData.ext_free }}</b>
                  </p>
                </li>
                <!-- <li class="d-flex d-just-space pt-2 pb-3">
                <div>Extended Free Trial</div>
                <div>
                  <b>250</b>
                </div>
                </li>-->
              </ul>
            </div>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-2">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Pharmacy</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0">
                    <b class="text-till">{{ pharmacyData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Diagnostics card -->
        <div class="col-3 cursor" @click="goToSubscriptionListing('diagnostics-lab')">
          <div class="cardbox theme--light v-card border-radius-4 h-100">
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <diagnosticSVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Diagnostics</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ diagnosticsData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="diagnosticsData.growth > 0" />
                    <upArrowSVG v-if="diagnosticsData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <div>
              <ul class="w-100 pl-6 pr-8 mb-0">
                <li class="d-flex d-just-space pt-4 pb-3">
                  <p class="mb-0 fz-16">Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ diagnosticsData.free_trial }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Active</p>
                  <p class="mb-0 fz-16">
                    <b>{{ diagnosticsData.basic }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Expired</p>
                  <p class="mb-0 fz-16">
                    <b>{{ diagnosticsData.expired }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-3 pb-4">
                  <p class="mb-0 fz-16">Extended Free trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ diagnosticsData.ext_free }}</b>
                  </p>
                </li>
                <!-- <li class="d-flex d-just-space pt-2 pb-3">
                <div>Extended Free Trial</div>
                <div>
                  <b>250</b>
                </div>
                </li>-->
              </ul>
            </div>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-2">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Diagnostics</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0">
                    <b class="text-till">{{ diagnosticsData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Blood Bank card -->
        <div class="col-3 cursor" @click="goToSubscriptionListing('bloodbank')">
          <div class="cardbox theme--light v-card border-radius-4 h-100">
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <ambulanceSVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Blood Bank</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ bloodbankData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="bloodbankData.growth > 0" />
                    <upArrowSVG v-if="bloodbankData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <div>
              <ul class="w-100 pl-6 pr-8 mb-0">
                <li class="d-flex d-just-space pt-4 pb-3">
                  <p class="mb-0 fz-16">Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ bloodbankData.free_trial }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Active</p>
                  <p class="mb-0 fz-16">
                    <b>{{ bloodbankData.basic }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-2 pb-3">
                  <p class="mb-0 fz-16">Expired</p>
                  <p class="mb-0 fz-16">
                    <b>{{ bloodbankData.expired }}</b>
                  </p>
                </li>
                <li class="d-flex d-just-space pt-3 pb-4">
                  <p class="mb-0 fz-16">Extended Free Trial</p>
                  <p class="mb-0 fz-16">
                    <b>{{ bloodbankData.ext_free }}</b>
                  </p>
                </li>
              </ul>
            </div>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-2">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Bloodbank</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0">
                    <b class="text-till">{{ bloodbankData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>

        <!-- Ambulance card -->
        <div class="col-3 cursor" @click="goToSubscriptionListing('ambulance')">
          <div class="cardbox theme--light v-card border-radius-4">
            <div
              class="card-headerbox d-flex justify-start align-center border-bottom w-100 pl-6 pr-8 pt-3 pb-3"
            >
              <span class="cardsvgicon border-radius-50 lightsuccesscolor">
                <ambulanceSVG />
              </span>
              <div class="pl-5">
                <h3 class="pt-0 mb-0">Ambulance</h3>
                <p v-if="tabName === 'week' || tabName === 'month'">
                  <span class="percentNumber">
                    <b>{{ ambulanceData.growth }}%</b>
                  </span>
                  <span class="indicator fillarrowstroke">
                    <upArrowSVG v-if="ambulanceData.growth > 0" />
                    <upArrowSVG v-if="ambulanceData.growth < 0" class="reverse reject-text" />
                  </span>
                  <span></span>
                  than last
                  {{ tabName === "week" ? "week" : "month" }}
                </p>
              </div>
            </div>
            <ul class="w-100 pl-6 pr-8 mb-0">
              <li class="d-flex d-just-space align-center pt-4 pb-3">
                <p class="mb-0 fz-16">Free Trial</p>
                <p class="mb-0 fz-16">
                  <b>{{ ambulanceData.free_trial }}</b>
                </p>
              </li>
              <li class="d-flex d-just-space align-center pt-2 pb-3">
                <p class="mb-0 fz-16">Active</p>
                <p class="mb-0 fz-16">
                  <b>{{ ambulanceData.basic }}</b>
                </p>
              </li>
              <li class="d-flex d-just-space align-center pt-2 pb-3">
                <p class="mb-0 fz-16">Expired</p>
                <p class="mb-0 fz-16">
                  <b>{{ ambulanceData.expired }}</b>
                </p>
              </li>
              <li class="d-flex d-just-space align-center pt-3 pb-4">
                <p class="mb-0 fz-16">Extended Free Trial</p>
                <p class="mb-0 fz-16">
                  <b>{{ ambulanceData.ext_free }}</b>
                </p>
              </li>
            </ul>
            <div class="card-footerbox d-flex d-just-space border-top w-100">
              <ul class="w-100 pl-6 pr-8 mb-0 pt-3 pb-3">
                <li class="d-flex d-just-space">
                  <p class="mb-0 fz-16">
                    <b>Total no. of Ambulance</b>
                  </p>
                  <p class="fz-18 xs-fz-16 mb-0">
                    <b class="text-till">{{ ambulanceData.total }}</b>
                  </p>
                </li>
              </ul>
            </div>
          </div>
        </div>
      </div>
    </div>
    <div class="arrow-box d-flex mt-7 cursor">
      <div
        class="slideleft slidearrow mr-2"
        @mousedown="scroll(-500)"
        @mouseup="stopScroll()"
        :class="{ active: leftLock }"
      >
        <leftarrowSVG />
        <!-- {{ leftLock }}  -->
      </div>
      <div
        class="slideright slidearrow pos-a"
        @mousedown="scroll(500)"
        @mouseup="stopScroll()"
        :class="{ active: rightLock }"
      >
        <RightarrowSVG />
        <!-- {{ rightLock }} -->
      </div>
    </div>

    <div class="row ml-0 mr-0 pt-7">
      <div class="col-8 pl-0 pr-0 expiredsubbox">
        <div class="subsciptionbox theme--light v-card border-radius-4">
          <div>
            <div class="pl-7 pt-5 pb-2 border-bottom">
              <h4 class="xs-fz-20">Recently Expired Subscriptions</h4>
            </div>
            <v-tabs
              v-model="tabs"
              background-color="transparent"
              class="border-bottom theme--light v-card"
            >
              <v-tab class="tabBox" v-for="(item, i) in items" :key="i">
                {{
                item.tabName
                }}
              </v-tab>
              <!-- <v-tab>Sent Messages</v-tab> -->
            </v-tabs>
            <v-tabs-items v-model="tabs">
              <v-tab-item>
                <recent-expiry-lists :isDashboard="true" :currentRole="'doctor'" v-if="tabs == 0"></recent-expiry-lists>
              </v-tab-item>

              <v-tab-item>
                <recent-expiry-lists :isDashboard="true" :currentRole="'pharmacy'" v-if="tabs == 1"></recent-expiry-lists>
              </v-tab-item>

              <v-tab-item>
                <recent-expiry-lists
                  :isDashboard="true"
                  :currentRole="'diagnostics-lab'"
                  v-if="tabs == 2"
                ></recent-expiry-lists>
              </v-tab-item>

              <v-tab-item>
                <recent-expiry-lists
                  :isDashboard="true"
                  :currentRole="'bloodbank'"
                  v-if="tabs == 3"
                ></recent-expiry-lists>
              </v-tab-item>

              <v-tab-item>
                <recent-expiry-lists
                  :isDashboard="true"
                  :currentRole="'ambulance'"
                  v-if="tabs == 4"
                ></recent-expiry-lists>
              </v-tab-item>
              <v-tab-item>
                <recent-expiry-lists :isDashboard="true" :currentRole="'allied'" v-if="tabs == 5"></recent-expiry-lists>
              </v-tab-item>
            </v-tabs-items>
          </div>
        </div>
      </div>
      <div class="col-4 expiredsubbox pl-7 pr-0">
        <div class="activesubscriptionbox theme--light v-card border-radius-4 pa-5">
          <h4 class="xs-fz-20 pt-4 pb-8">Active Subscriptions</h4>
          <div class="canvasbox">
            <CChartDoughnut
              :datasets="defaultDatasets"
              :options="{
                legend: {
                  display: false,
                },
                cutoutPercentage: 85,
              }"
            />
            <div class="chartbox pt-8">
              <ul class="pl-0 mb-2">
                <!-- Doctor -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bgblue border-radius-2 mr-4"></span>Doctor
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription.doctor }}%</b>
                  </p>
                </li>

                <!-- ambulance -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bgGreen border-radius-2 mr-4"></span>Ambulance
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription.ambulance }}%</b>
                  </p>
                </li>

                <!-- Pharmacy -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bgyellow border-radius-2 mr-4"></span>Pharmacy
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription.pharmacy }}%</b>
                  </p>
                </li>

                <!-- Diagnostics -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bgorange border-radius-2 mr-4"></span>Diagnostics
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription["diagnostics-lab"] }}%</b>
                  </p>
                </li>

                <!-- Blood Bank -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bgred border-radius-2 mr-4"></span>Blood
                    Bank
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription.bloodbank }}%</b>
                  </p>
                </li>

                <!-- Allied -->
                <li class="d-just-space mb-4">
                  <p class="mb-0 fz-16">
                    <span class="box bggreen border-radius-2 mr-4"></span>Allied
                  </p>
                  <p class="mb-0 fz-16">
                    <b>{{ activeSubscription.allied }}%</b>
                  </p>
                </li>
              </ul>
            </div>
            <!-- <v-skeleton-loader
              v-bind="attrs"
              type="image,list-item-avatar, divider ,list-item-avatar, divider ,list-item-avatar, divider ,list-item-avatar, divider ,list-item-avatar, divider ,list-item-avatar"
            ></v-skeleton-loader>-->
          </div>
        </div>
      </div>
    </div>
  </div>
</template>
<script>
import config from "@/config.js";
import { pickSvg } from "@/views/SVG";
import Datepicker from "v-calendar/lib/components/date-picker.umd";
import { CChartDoughnut } from "@coreui/vue-chartjs";
const recentExpiryLists = () =>
  import("@/components/subscriptions/recentExpiryLists.vue");
export default {
  data() {
    return {
      tabs: null,
      items: [
        { tabName: "Doctor " },
        { tabName: "Pharmacy" },
        { tabName: "Diagnostics-lab" },
        { tabName: "Blood Bank" },
        { tabName: "Ambulance" },
        { tabName: "Allied" }
      ],
      joinOnDateRange: { start: "", end: "" },
      datePickerConfig: {
        start: {
          timeAdjust: "00:00:00"
        },
        end: {
          timeAdjust: "23:59:59"
        }
      },
      doctorData: {},
      alliedData: {},
      pharmacyData: {},
      diagnosticsData: {},
      bloodbankData: {},
      ambulanceData: {},
      tabName: "all",
      // isActive: false,
      activeSubscription: {},
      direction: 0,
      interval: undefined,
      leftLock: true,
      rightLock: false
    };
  },
  components: {
    "recent-expiry-lists": recentExpiryLists,
    CChartDoughnut,
    Datepicker,
    ...pickSvg(
      "crossSVG",
      "verticalDotsSVG",
      "chevronSVG",
      "doctorSVG",
      "ambulanceSVG",
      "upArrowSVG",
      "diagnosticSVG",
      "calendarSVG",
      "pharmacySVG",
      "leftarrowSVG",
      "RightarrowSVG"
    )
  },
  mounted() {
    this.getSubscriptionDashboardData(this.tabName);
  },
  methods: {
    // toggleClass() {
    //   this.isActive = !this.isActive;
    //   this.siblings().isActive = false;
    // },

    getSubscriptionDashboardData(filter) {
      let params = {
        filter: filter
      };
      if (this.joinOnDateRange.start !== "") {
        (params.start_date = this.joinOnDateRange.start.toISOString()),
          (params.end_date = this.joinOnDateRange.end.toISOString());
      }
      let url = `${config.BASE_URL}api/v2/admin/subscription/dashboard`;
      this.$http.get(url, { params }).then(response => {
        if (response.body.status) {
          this.doctorData = response.body.data.doctor;
          this.alliedData = response.body.data.allied;
          this.pharmacyData = response.body.data.pharmacy;
          this.diagnosticsData = response.body.data["diagnostics-lab"];
          this.bloodbankData = response.body.data.bloodbank;
          this.ambulanceData = response.body.data.ambulance;
          this.activeSubscription = response.body.data.active_subscription;
        }
      });
    },
    recentSubscription() {
      this.$router.push("/recentlyexpired-subscriptions");
    },
    resetJoiningDate() {
      this.joinOnDateRange = { start: "", end: "" };
      this.getSubscriptionDashboardData((this.tabName = "all"));
    },
    // for date range filter call
    dateChange() {
      this.getSubscriptionDashboardData((this.tabName = "custom"));
    },
    goToRecentSubscription(currentRole) {
      this.$router.push({
        name: "Recently Expired Subscriptions",
        params: { from: currentRole }
      });
    },
    goToSubscriptionListing(role) {
      this.$router.push({
        name: "Subscription Reports",
        params: { role: role, selectedDate: this.tabName, selectedTime: this.joinOnDateRange }
      });
    },
    scroll(direction) {
      if (direction < 0) {
        this.leftLock = true;
        this.rightLock = false;
      }
      if (direction > 0) {
        this.leftLock = false;
        this.rightLock = true;
      }
      this.interval = setInterval(() => {
        this.direction = direction;
        const element = this.$refs.ss;
        element.scrollBy({
          top: 0,
          left: this.direction,
          behavior: "smooth"
        });
      }, 10);
    },
    stopScroll() {
      this.direction = 0;
      clearInterval(this.interval);
    }
  },
  computed: {
    defaultDatasets() {
      return [
        {
          backgroundColor: [
            "#0558ff",
            "#019f99",
            "#ffc700",
            "#f99600",
            "#b30302",
            "#13c439"
          ],
          data: [
            this.activeSubscription.doctor,
            this.activeSubscription.ambulance,
            this.activeSubscription.pharmacy,
            this.activeSubscription["diagnostics-lab"],
            this.activeSubscription.bloodbank,
            this.activeSubscription.allied
          ]
        }
      ];
    }
  }
};
</script>